// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Download Page Styles */
.download-page {
  font-family: 'Arial', sans-serif; 
  text-align: center;
  background: #fce4ec; /* Light pink background */
  min-height: 100vh;
  padding: 2rem; 
}

.user-info,
.download-table {
  text-align: center;
  width: 600px;
  margin: 1.5rem auto; 
  background: white;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px; 
  padding: 1.5rem; 
  transition: box-shadow 0.3s ease;
}

.red-text {
  color: #e91e63; /* Darker pink for emphasis */
  font-weight: bold;
}

.user-info img {
  height: 100px;
  width: 100px;
  border-radius: 50%; 
  transition: transform 0.3s ease; 
}

.user-info:hover,
.download-table:hover {
  box-shadow: rgba(0, 0, 0, 0.4) 0px 10px 20px; 
}

.user-info:hover img {
  transform: scale(1.05); 
}
.button {
  min-width: 150px; /* Set your desired minimum width */
  max-width: auto; /* This can be omitted, as 'auto' is the default */
  background-color: #e91e63; /* Pink button color */
  border: none;
  outline: none;
  height: 40px; 
  border-radius: 20px; 
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  margin: 15px 0; 
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s; 
}

.button:hover {
  transform: scale(1.05); /* Slightly increase size on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add shadow on hover */
}
/* .button:hover {
  transform: translateY(-3px) scale(1.05); 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); 
} */

/* Adjustments for tablet and mobile screens (max-width 767px) */
@media only screen and (max-width: 767px) {
  .user-info,
  .download-table {
    width: 90%; 
  }
  .button {
    width: 50%;  /* Make the button width 80% of its container */
    height: 35px; /* Slightly smaller height */
    font-size: 14px; /* Adjust font size */
  }
}

/* Additional adjustments for even smaller screens (max-width 480px) */
@media only screen and (max-width: 480px) {
  .user-info img {
    height: 120px; 
  }

  .download-table {
    font-size: 14px; 
  }
  .button {
    width: 50%; /* Full width for smaller screens */
    height: 35px; /* Further reduce height */
    font-size: 12px; /* Smaller font size */
  }
}
`, "",{"version":3,"sources":["webpack://./src/DownloadPdf/Downloadpdf.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc,EAAE,6BAA6B;EAC7C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,eAAe,EAAE,kDAAkD;EACnE,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB,EAAE,oCAAoC;EAC5D,wCAAwC,EAAE,wBAAwB;AACpE;AACA;;;GAGG;;AAEH,gEAAgE;AAChE;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU,GAAG,+CAA+C;IAC5D,YAAY,EAAE,4BAA4B;IAC1C,eAAe,EAAE,qBAAqB;EACxC;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,UAAU,EAAE,mCAAmC;IAC/C,YAAY,EAAE,0BAA0B;IACxC,eAAe,EAAE,sBAAsB;EACzC;AACF","sourcesContent":["/* Download Page Styles */\n.download-page {\n  font-family: 'Arial', sans-serif; \n  text-align: center;\n  background: #fce4ec; /* Light pink background */\n  min-height: 100vh;\n  padding: 2rem; \n}\n\n.user-info,\n.download-table {\n  text-align: center;\n  width: 600px;\n  margin: 1.5rem auto; \n  background: white;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px; \n  padding: 1.5rem; \n  transition: box-shadow 0.3s ease;\n}\n\n.red-text {\n  color: #e91e63; /* Darker pink for emphasis */\n  font-weight: bold;\n}\n\n.user-info img {\n  height: 100px;\n  width: 100px;\n  border-radius: 50%; \n  transition: transform 0.3s ease; \n}\n\n.user-info:hover,\n.download-table:hover {\n  box-shadow: rgba(0, 0, 0, 0.4) 0px 10px 20px; \n}\n\n.user-info:hover img {\n  transform: scale(1.05); \n}\n.button {\n  min-width: 150px; /* Set your desired minimum width */\n  max-width: auto; /* This can be omitted, as 'auto' is the default */\n  background-color: #e91e63; /* Pink button color */\n  border: none;\n  outline: none;\n  height: 40px; \n  border-radius: 20px; \n  color: #fff;\n  text-transform: uppercase;\n  font-weight: bold;\n  margin: 15px 0; \n  cursor: pointer;\n  transition: transform 0.3s, box-shadow 0.3s; \n}\n\n.button:hover {\n  transform: scale(1.05); /* Slightly increase size on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add shadow on hover */\n}\n/* .button:hover {\n  transform: translateY(-3px) scale(1.05); \n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); \n} */\n\n/* Adjustments for tablet and mobile screens (max-width 767px) */\n@media only screen and (max-width: 767px) {\n  .user-info,\n  .download-table {\n    width: 90%; \n  }\n  .button {\n    width: 50%;  /* Make the button width 80% of its container */\n    height: 35px; /* Slightly smaller height */\n    font-size: 14px; /* Adjust font size */\n  }\n}\n\n/* Additional adjustments for even smaller screens (max-width 480px) */\n@media only screen and (max-width: 480px) {\n  .user-info img {\n    height: 120px; \n  }\n\n  .download-table {\n    font-size: 14px; \n  }\n  .button {\n    width: 50%; /* Full width for smaller screens */\n    height: 35px; /* Further reduce height */\n    font-size: 12px; /* Smaller font size */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
